import { render } from "./CompaniesGridView.vue?vue&type=template&id=f8bba11e&ts=true"
import script from "./CompaniesGridView.vue?vue&type=script&lang=ts"
export * from "./CompaniesGridView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__